export default "__VITE_ASSET__CQOqjj_c__"